/*
devuelve true si la cadena `query` esta incluida en la cadena `string`
*/

import { _cleanSearchArguments } from './_cleanSearchArguments';

export function includes(...args) {
  const { string, query } = _cleanSearchArguments.apply(null, args);
  return string.includes(query);
}
